export const multiselect = {
  placeholder: 'Selectează',
  selectLabel: 'Selectează',
  selectedLabel: 'Selectat',
  selectGroupLabel: 'ENTER pt select grup',
  deselectLabel: 'ENTER pt deselect',
  deselectGroupLabel: 'ENTER pt deselect grup',
  tagPlaceholder: 'ENTER pt a crea',
  noResult: 'Niciun rezultat găsit',
  noOptions: 'Niciun rezultat'
}
